// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6df65682","453":"bb68eab6","455":"0d1c2867","977":"7bc6fe9d"}[chunkId] + ".chunk.js";
};